import { createAction, props } from '@ngrx/store';
import { PaginationRequest } from 'src/app/models/common/paginationRequest';
import { ContractDTO } from 'src/app/models/Contracts/contractDTO';
import { LimitDTO } from 'src/app/models/limits/limitDTO';

// PlafondRules
export const getPlafondRules = createAction('[Contracts] Get All Contracts PlafondRules Action', props<{ pageReq: PaginationRequest }>());
export const loadPlafondRules = createAction('[Contracts] Load All Contracts PlafondRules Action', props<{ response: any[] }>());
// PlafondMeasurements
export const getPlafondMeasurements = createAction('[Contracts] Get All Contracts PlafondMeasurements Action',
    props<{ pageReq: PaginationRequest }>());
export const loadPlafondMeasurements = createAction('[Contracts] Load All Contracts PlafondMeasurements Action',
    props<{ response: any[] }>());
// Contracts
export const loadContracts = createAction('[Contracts] Load All Contracts Action', props<{ response: any[] }>());
export const createContract = createAction('[Contracts] Create Contract Action', props<{ contract: ContractDTO }>());
export const updateContract = createAction('[Contracts] Update Contract Action', props<{ contract: ContractDTO }>());
export const getContract = createAction('[Contracts] Get a Contract by code Action', props<{ contractCode: string }>());
export const resetContract = createAction('[Contracts] Reset Contract Action');
export const setContract = createAction('[Contracts] Set Contract Action', props<{ contract: ContractDTO }>());
export const getContractList = createAction('[Contracts] Get All Contract List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadContractList = createAction('[Contracts] Load All Contract List Action',
    props<{ response: any }>());
export const getContractCardList = createAction('[Contracts] Get All Cards by Contract List Action',
    props<{ container: any, options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadContractCardsList = createAction('[Contracts] Load All Cards by Contract List Action',
    props<{ response: any }>());
export const getContractMovementList = createAction('[Contracts] Get a Contract Movements by code Action',
    props<{ itemCode: string, options: any }>());
export const loadContractMovementList = createAction('[Contracts] Load All Contract Movements List Action',
    props<{ response: any[] }>());
// Loading Actions
export const getLoadingContractsState = createAction('[Contracts] Get Contracts Loading State Action');
export const setLoadingContractsStartState = createAction('[Contracts] Set Contracts Loading Start State Action');
export const setLoadingContractsEndState = createAction('[Contracts] Set Contracts Loading End State Action');
// ProductGroups
export const getProductGroups = createAction('[Contracts] Get All Contracts ProductGroups Action', props<{ pageReq: PaginationRequest }>());
export const getProductGroupsList = createAction('[Contracts] Get Contracts ProductGroups List Action', props<{ options: any }>());
export const loadProductGroups = createAction('[Contracts] Load All Contracts ProductGroups Action', props<{ response: any[] }>());
export const deleteContractProductGroup = createAction('[Contracts] Delete Contract ProductGroups Action',
    props<{ contractCode: string, productGroupCodes: string[] }>());
export const updateContractProductGroups = createAction('[Contracts] Update Contract Product Groups Action',
    props<{ contractCode: string, productGroups: string[] }>());
// Sites
export const getSitesList = createAction('[Contracts] Get Sites List Action', props<{ options: any }>());
export const loadSitesList = createAction('[Contracts] Load Sites Action', props<{ response: any[] }>());
// Limits
export const getLimitIntervals = createAction('[Contracts] Get All Contracts LimitIntervals Action',
    props<{ pageReq: PaginationRequest }>());
export const loadLimitIntervals = createAction('[Contracts] Load All Contracts LimitIntervals Action', props<{ response: any[] }>());
export const getLimitMeasurements = createAction('[Contracts] Get All Contracts LimitMeasurements Action',
    props<{ pageReq: PaginationRequest }>());
export const loadLimitMeasurements = createAction('[Contracts] Load All Contracts LimitMeasurements Action', props<{ response: any[] }>());
export const saveContractLimits = createAction('[Contracts] Save Contract Limits Action',
    props<{ contractCode: string, contractLimitCodes: any[] }>());
export const deleteContractLimits = createAction('[Contracts] Delete Contract Limits Action',
    props<{ contractCode: string, contractLimitCodes: any[] }>());
export const resetContractLimit = createAction('[Contracts] Reset Contract Limits Action',
    props<{ contractCode: string, limitCode: string }>());
export const resetContractPlafond = createAction('[Contracts] Reset Contract Plafond Action',
    props<{ contractCode: string }>());
export const resetContractsState = createAction('[Contracts] Reset Contracts State Action');
export const resetCreation = createAction("[Contracts] Reset Creation Action");
export const getContractExcelList = createAction('[Contracts] Get a Contract Excel List Action',
    props<{  options: any }>());
export const loadContractExcelList = createAction('[Contracts] Load All Contract Excel List Action',
    props<{ response: any[] }>());
export const updateContractLimits = createAction('[Contracts] Update Contract Limits Action',
    props<{ contractCode: string, limits: LimitDTO[] }>());

// Contracts Table Configuration Settings
export const getContractTableConfig = createAction(
  "[Contracts] Get Contract Table Configuration Action",
  props<{ options: any }>()
);
export const loadContractTableConfig = createAction(
  "[Contracts] Load Contract Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveContractTableConfig = createAction(
  "[Contracts] Save Contract Table Configuration Action",
  props<{ config: any }>()
);
